import * as Bixby from '$/core';

export interface ResetPasswordState {
  isLoading: boolean;
  error?: string;
  success: boolean;
  tokenInvalid: boolean;
}

export const RESET_PASSWORD_INPROGESS = 'RESET_PASSWORD_INPROGESS';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';
export const VERIFY_RESET_PASSWORD_INPROGESS = 'VERIFY_RESET_PASSWORD_INPROGESS';
export const VERIFY_RESET_PASSWORD_SUCCESS = 'VERIFY_RESET_PASSWORD_SUCCESS';
export const VERIFY_RESET_PASSWORD_FAILURE = 'VERIFY_RESET_PASSWORD_FAILURE';

interface ResetPasswordInProgress extends Bixby.Models.BixbyAction {
  type: typeof RESET_PASSWORD_INPROGESS;
}

interface ResetPasswordRequestSuccess extends Bixby.Models.BixbyAction {
  type: typeof RESET_PASSWORD_SUCCESS;
}

interface ResetPasswordRequestFailure extends Bixby.Models.BixbyAction {
  type: typeof RESET_PASSWORD_FAILURE;
  payload: Bixby.Models.BixbyError;
}

interface VerifyResetPasswordInProgress extends Bixby.Models.BixbyAction {
  type: typeof VERIFY_RESET_PASSWORD_INPROGESS;
}

interface VerifyResetPasswordRequestSuccess extends Bixby.Models.BixbyAction {
  type: typeof VERIFY_RESET_PASSWORD_SUCCESS;
  payload: boolean;
}

interface VerifyResetPasswordRequestFailure extends Bixby.Models.BixbyAction {
  type: typeof VERIFY_RESET_PASSWORD_FAILURE;
  payload: Bixby.Models.BixbyError;
}

export type ResetPasswordActionTypes =
  | ResetPasswordInProgress
  | ResetPasswordRequestSuccess
  | ResetPasswordRequestFailure
  | VerifyResetPasswordInProgress
  | VerifyResetPasswordRequestSuccess
  | VerifyResetPasswordRequestFailure;
